import { useMemo } from 'react';

import { useFeatureGate } from '@m/hooks/data/featureFlags';

/**
 * Statsig gate for the begin-payment flow on the text-to-pay page (EN-14169). Evaluated per site so it
 * can be rolled out alongside the legacy per-site flag that keeps the revenue transaction active until
 * payment begins (EN-14168).
 */
export const TEXT_TO_PAY_BEGIN_PAYMENT_GATE = 'web_pay_ttp-begin-payment-enabled';

/**
 * Fails closed: pending, error and `enabled: false` all keep the pre-existing behavior (confirm with
 * Stripe straight away, no idle refetch), so a gate outage can never block a payment.
 */
export function useBeginPaymentGate(siteId: number) {
  const context = useMemo(() => ({ siteId }), [siteId]);
  const { data } = useFeatureGate(TEXT_TO_PAY_BEGIN_PAYMENT_GATE, context);
  return data?.enabled === true;
}
